import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=f07ea32c"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=f07ea32c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports